/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { CacheMeta } from './CacheMeta';
import {
    CacheMetaFromJSON,
    CacheMetaFromJSONTyped,
    CacheMetaToJSON,
    CacheMetaToJSONTyped,
} from './CacheMeta';
import type { DigiticketsSessionsOverview } from './DigiticketsSessionsOverview';
import {
    DigiticketsSessionsOverviewFromJSON,
    DigiticketsSessionsOverviewFromJSONTyped,
    DigiticketsSessionsOverviewToJSON,
    DigiticketsSessionsOverviewToJSONTyped,
} from './DigiticketsSessionsOverview';

/**
 * 
 * @export
 * @interface ListDigiticketsSessionsOverviewsResponse
 */
export interface ListDigiticketsSessionsOverviewsResponse {
    /**
     * 
     * @type {CacheMeta}
     * @memberof ListDigiticketsSessionsOverviewsResponse
     */
    cache: CacheMeta;
    /**
     * 
     * @type {Array<DigiticketsSessionsOverview>}
     * @memberof ListDigiticketsSessionsOverviewsResponse
     */
    data: Array<DigiticketsSessionsOverview>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListDigiticketsSessionsOverviewsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListDigiticketsSessionsOverviewsResponse interface.
 */
export function instanceOfListDigiticketsSessionsOverviewsResponse(value: object): value is ListDigiticketsSessionsOverviewsResponse {
    if (!('cache' in value) || value['cache'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListDigiticketsSessionsOverviewsResponseFromJSON(json: any): ListDigiticketsSessionsOverviewsResponse {
    return ListDigiticketsSessionsOverviewsResponseFromJSONTyped(json, false);
}

export function ListDigiticketsSessionsOverviewsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDigiticketsSessionsOverviewsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cache': CacheMetaFromJSON(json['cache']),
        'data': ((json['data'] as Array<any>).map(DigiticketsSessionsOverviewFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListDigiticketsSessionsOverviewsResponseToJSON(json: any): ListDigiticketsSessionsOverviewsResponse {
      return ListDigiticketsSessionsOverviewsResponseToJSONTyped(json, false);
  }

  export function ListDigiticketsSessionsOverviewsResponseToJSONTyped(value?: ListDigiticketsSessionsOverviewsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cache': CacheMetaToJSON(value['cache']),
        'data': ((value['data'] as Array<any>).map(DigiticketsSessionsOverviewToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

